const environment = {
  development: {
    isProduction: false,
    isDevelopment: true,
  },
  production: {
    isProduction: true,
    externalApiPath: 'https://api.takemetour.com',
    apiPath: process.env.APIPATH || 'http://production-api-service:3000',
    socketPath: process.env.SOCKETPATH || 'http://production-socketio-service:3000/ws',
    memcached: 'production-memcached:11211',
    // apiPath: process.env.APIPATH || 'https://api.takemetour.com',
    // socketPath:
    //   process.env.SOCKETPATH || 'https://socketio.takemetour.com/ws',
    // mixpanel: { token: 'd96aeba37ec23f947678c31da6f2078c' },
    mediaPath: 'https://d1j7gws94ta18j.cloudfront.net',
    s3Bucket: 'takemetour-3-0',
    // directMediaPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0',
    distPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-assets',
    assetPath: 'https://d34z6m0qj7i7g9.cloudfront.net',
    gaToken: 'UA-48143288-4',
    baseURL: {
      en: 'https://www.takemetour.com',
      th: 'https://pachantiew.takemetour.com',
      zh: 'https://zh.takemetour.com',
      au: 'https://www.takemetour.com.au',
    },
    gaTokens: { en: 'UA-48143288-4', th: 'UA-48143288-6', zh: 'UA-48143288-7', au: 'UA-48143288-11' },
    // uiKitAssetPath: 'https://d11wu5ues9vu9e.cloudfront.net',
    uiKitAssetPath: 'https://ddhiorx9qbcay.cloudfront.net',
    googleTagManagerContainer: 'GTM-KG7CMT',
  },
  staging: {
    isProduction: true,
    externalApiPath: 'https://api.staging.takemetour.com',
    apiPath: process.env.APIPATH || 'http://staging-api-service:3000',
    memcached: 'staging-memcached:11211',
    socketPath: process.env.SOCKETPATH || 'http://staging-socketio-service:3000/ws',
    mediaPath: 'https://d3uplctqj7yzf0.cloudfront.net',
    s3Bucket: 'takemetour-3-0-dev',
    distPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-dev-assets',
    assetPath: 'https://d2ohnhq02bju9i.cloudfront.net',
    baseURL: {
      en: 'https://staging.takemetour.com',
      th: 'http://pachantiew.staging.takemetour.com',
      zh: 'http://zh.staging.takemetour.com',
      au: 'https://staging.takemetour.com.au',
    },
    uiKitAssetPath: 'https://takemetour-uikit-asset-dev.storage.googleapis.com',
    googleTagManagerContainer: 'GTM-P49PLX3',
  },
}[process.env.ENV || process.env.NODE_ENV || 'development'];

module.exports = Object.assign(
  {
    host: process.env.HOST || 'localhost',
    port: process.env.PORT,
    baseURL: {
      en: `http://${process.env.HOST || 'localhost'}:${process.env.PORT || 3000}`,
      th: `http://${process.env.HOST || 'th.localhost'}:${process.env.PORT || 3000}`,
      zh: `http://${process.env.HOST || 'zh.localhost'}:${process.env.PORT || 3000}`,
    },
    assetPath: '',
    externalApiPath: 'https://api.staging.takemetour.com',
    apiPath: process.env.APIPATH || 'https://api.staging.takemetour.com',
    // uiKitAssetPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-uikit-asset-dev',
    uiKitAssetPath: 'https://takemetour-uikit-asset-dev.storage.googleapis.com',
    // apiPath: process.env.APIPATH || 'https://api.takemetour.com',
    socketPath: process.env.SOCKETPATH || 'http://socketio.staging.takemetour.com/ws',
    // process.env.SOCKETPATH || 'https://socketio.takemetour.com/ws',
    app: {
      title: 'TakeMeTour',
      description: 'Book budget private tours with real locals',
      head: {
        titleTemplate: "%s | TakeMeTour - See Thailand through the local's eyes",
        meta: [
          {
            name: 'description',
            content: 'Book budget private tours with real locals',
          },
          { charset: 'utf-8' },
          {
            property: 'og:site_name',
            content: "TakeMeTour - See Thailand through the local's eyes",
          },
          {
            property: 'og:image',
            content: 'theme/images/favicons/favicon-32x32.png',
          },
          { property: 'og:locale', content: 'en_US' },
          { property: 'og:title', content: 'Home' },
          {
            property: 'og:description',
            content: 'Book budget private tours with real locals',
          },
          { property: 'og:card', content: 'summary' },
          { property: 'og:image:width', content: '200' },
          { property: 'og:image:height', content: '200' },
        ],
      },
    },
    weibo: {
      zh: {
        oAuthUrl: 'https://api.weibo.com/oauth2/authorize',
        clientId: '1119250595',
        redirectUri: 'https://zh.takemetour.com/weibo/callback',
      },
    },
    // lineNotify: {
    //   en: {
    //     oAuthUrl: 'https://notify-bot.line.me/oauth/authorize',
    //     clientId: 'sotqhrSF59ZwK8JjrUXyHL',
    //     redirectUri: 'https://www.takemetour.com/dashboard/settings', // comment
    //   },
    // },
    gaToken: 'UA-48143288-5',
    gaTokens: { en: 'UA-48143288-5', th: 'UA-48143288-5', zh: 'UA-48143288-5', au: 'UA-140710472-2' },
    mediaPath: 'https://d3uplctqj7yzf0.cloudfront.net',
    s3Bucket: 'takemetour-3-0-dev',
    // directMediaPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-dev', // comment
    // mediaPath: 'https://dglw4xbnd0ycq.cloudfront.net',
    mobileConnect: {
      redirectURI: 'https://www.takemetour.com/scripts/DiscoveryComplete.html',
    },
    // mixpanel: { token: 'c5c372ecf4cd51d06a7824df7b5d7358' },
    prefetchPath: '/assets.json',
    facebookAppId: '512381822169849',
    googleClientId: '1087964454414-pnm60fbegh6cec6m0rvk9eienko254pj.apps.googleusercontent.com',
    storage: {
      bucket: 'takemetour-misc',
      path: 'tags/memcached/production'
    },
    mapApiKey: 'AIzaSyAk7-fUvGN1qcJSy4OfDWMabzkpHAL4gq4',
    googleTagManagerContainer: 'GTM-P49PLX3',
    firstBooking: 450,
    tgthAffiliateId: 'tagthai',
    tgthPartnerToastCookie: 'tgth_partner_toast_accepted',
  },
  environment
);
